import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22publicSerif.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./files/martina-plantijn-vf-roman.woff2%22,%22weight%22:%22300%20900%22,%22style%22:%22normal%22},{%22path%22:%22./files/martina-plantijn-vf-italic.woff2%22,%22weight%22:%22300%20900%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22fallback%22:[%22Georgia%22,%22serif%22],%22variable%22:%22--twt-public-serif%22}],%22variableName%22:%22publicSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'publicSerif', 'publicSerif Fallback', Georgia, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
